import React from 'react';
import { CheckCircle2, Truck } from 'lucide-react';
export function EBTWICBanner() {
  return <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-2 md:py-3 overflow-hidden" data-id="element-30">
      <div className="md:hidden" data-id="element-31">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-6" data-id="element-32">
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-33">
            <CheckCircle2 className="w-3.5 h-3.5 text-white/90 flex-shrink-0" data-id="element-34" />
            <span className="text-xs font-bold" data-id="element-35">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-white/20 text-white px-2.5 py-1 rounded-full" data-id="element-36">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-37" />
            <span className="text-xs font-bold" data-id="element-38">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-39">
            <Truck className="w-3.5 h-3.5 text-white/90 flex-shrink-0" data-id="element-40" />
            <span className="text-xs font-semibold" data-id="element-41">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-42">
            <CheckCircle2 className="w-3.5 h-3.5 text-white/90 flex-shrink-0" data-id="element-43" />
            <span className="text-xs font-bold" data-id="element-44">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-white/20 text-white px-2.5 py-1 rounded-full" data-id="element-45">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-46" />
            <span className="text-xs font-bold" data-id="element-47">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-48">
            <Truck className="w-3.5 h-3.5 text-white/90 flex-shrink-0" data-id="element-49" />
            <span className="text-xs font-semibold" data-id="element-50">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
        </div>
      </div>

      <div className="hidden md:block max-w-7xl mx-auto px-6" data-id="element-51">
        <div className="flex items-center justify-center gap-6 lg:gap-8 flex-wrap" data-id="element-52">
          <div className="flex items-center gap-2" data-id="element-53">
            <CheckCircle2 className="w-5 h-5 text-white/90" data-id="element-54" />
            <span className="text-sm font-semibold" data-id="element-55">WIC Approved</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-56">
            <CheckCircle2 className="w-5 h-5 text-white/90" data-id="element-57" />
            <span className="text-sm font-semibold" data-id="element-58">EBT/SNAP</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-59">
            <CheckCircle2 className="w-5 h-5 text-white/90" data-id="element-60" />
            <span className="text-sm font-semibold" data-id="element-61">USDA Partner</span>
          </div>
          <div className="flex items-center gap-2 bg-white/20 text-white px-3 py-1.5 rounded-full" data-id="element-62">
            <CheckCircle2 className="w-5 h-5" data-id="element-63" />
            <span className="text-sm font-bold" data-id="element-64">Free Delivery Over $35</span>
          </div>
          <div className="h-4 w-px bg-white/20" data-id="element-65" />
          <div className="flex items-center gap-3" data-id="element-66">
            <Truck className="w-5 h-5 text-white/90" data-id="element-67" />
            <span className="text-sm font-semibold" data-id="element-68">Available on:</span>
            <div className="flex items-center gap-2 text-xs font-medium" data-id="element-69">
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-70">Uber Eats</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-71">DoorDash</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-72">Instacart</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-73">GrubHub</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}